// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
	},
};

// Declare Templates
var boostPFSTemplate = {
	// Grid Template
	'productGridItemHtml': '<div id="{{itemHandle}}" class="grid__item grid-product ' + boostPFSConfig.custom.grid_item_width + ' {{itemQuickShopClass}}" data-aos="row-of-' + boostPFSConfig.custom.products_per_row + '">' +
								'<div class="grid-product__content">' +
									'{{itemSaleLabel}}' +
									'{{itemSoldOutLabel}}' +
									'{{itemQuickShopButton}}' +
									'<a href="{{itemUrl}}" class="grid-product__link {{itemSoldOutClass}}">' +
										'<div class="grid-product__image-mask">' +                                            
											'{{itemImages}}' +
										'</div>' +
										'<div class="grid-product__meta">' +
											'<div class="grid-product__title">{{itemTitle}}</div>' +
											'{{itemFitment}}' +
											'{{itemSku}}' +
											'{{itemVendor}}' +
											'<div class="grid-product__price">{{itemPrice}}</div>' +
											'{{itemReviews}}' +
										'</div>' +
									'</a>' +
									'{{itemSwatch}}' +
								'</div>' +                               
								'<div id="QuickShopModal-{{itemId}}" class="modal modal--square" data-product-id="{{itemId}}"></div>' +
							'</div>',

	// Pagination Template
	'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg><span class="icon__fallback-text">Previous</span></a></span>',
	'previousDisabledHtml': '',
	'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}" title=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg><span class="icon__fallback-text">Next</span></a></span>',
	'nextDisabledHtml': '',
	'pageItemHtml': '<span class="page"><a href="{{itemUrl}}" title="">{{itemTitle}}</a></span>',
	'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '<span class="deco">...</span>',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

	// Sorting Template
	'sortingHtml': '<label for="boost-pfs-filter-top-sorting-select" class="hidden-label">' + boostPFSConfig.label.sorting + '</label><select class="boost-pfs-filter-top-sorting-select">{{sortingItems}}</select>',
};

// ============================================================
// SSBC-USA: Extract vehicle fitment from product tags
// Used by both the Boost PFS card and Liquid product-grid-item
// ============================================================
function ssbcExtractFitment(tags) {
	if (!tags || !Array.isArray(tags) || tags.length === 0) return '';

	var makes  = ['Ford','Chevy','GM','GMC','Dodge','Ram','Jeep','Mercury','Pontiac','Buick','Oldsmobile','Chrysler','Lincoln','Mopar'];
	var models = ['F-250','F-350','F-150','F-450','Mustang','Excursion','Bronco','Ranger','CJ-5','CJ-7','CJ-10','Wrangler','Gladiator','Silverado','Sierra','C-10','2500','3500','1500','Dually','Durango','Cherokee','Comanche','Tahoe','Suburban','Blazer','S-10','Colorado','Canyon','Super Duty'];
	var yearRe = /^(19[5-9]\d|20[0-3]\d)$/;

	var tagMakes = [], tagModels = [], tagYears = [];
	tags.forEach(function(tag) {
		if (makes.indexOf(tag) !== -1 && tagMakes.indexOf(tag) === -1) tagMakes.push(tag);
		if (models.indexOf(tag) !== -1 && tagModels.indexOf(tag) === -1) tagModels.push(tag);
		if (yearRe.test(tag)) tagYears.push(tag);
	});

	if (tagMakes.length === 0) return '';

	tagYears.sort();
	var fitment = '';
	if (tagYears.length > 0) {
		fitment = (tagYears.length === 1)
			? tagYears[0] + ' '
			: tagYears[0] + '-' + tagYears[tagYears.length - 1] + ' ';
	}
	fitment += tagMakes.join('/');
	if (tagModels.length > 0) fitment += ' ' + tagModels.join('/');
	return fitment;
}

/************************** BUILD PRODUCT LIST **************************/
(function () { // Add this
	BoostPFS.inject(this); // Add this

	/* some code */
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
		if(!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
		var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
		for (var i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i];
			break;
			}
		}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Get Image size
		var imgSize = '450x650';
		switch (boostPFSConfig.custom.products_per_row) {
			case 5: imgSize = '350x550'; break;
			case 4: imgSize = '450x650'; break;
			case 3: imgSize = '450x650'; break;
			case 2: imgSize = '850x1050'; break;
			case 1: imgSize = '1400x1800'; break;
		}

		// Add Thumbnail
		var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : 1;
		var paddingBottom = images.length > 0 ? 100 / aspectRatio : 100;
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], imgSize) : boostPFSConfig.general.no_image_url;
      	var thumb = images.length > 0 ? images[0] : {src: boostPFSConfig.general.no_image_url, width: 500, height: 500};
		var bgset = buildBgSet(thumb);
		var itemImagesHtml = '';
		if(boostPFSConfig.custom.product_grid_image_size == 'natural'){
			itemImagesHtml += '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">' +
								'<img ' +
								'class="grid-view-item__image lazyload" ' +
								'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
								'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
								'data-aspectratio="' + aspectRatio + '" ' +
								'data-sizes="auto" ' +
								'alt="{{itemTitle}}">' +
								'</div>';
		if (!soldOut) {
			if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
				bgset = buildBgSet(images[1]);
				itemImagesHtml += '<div ' +
					'class="grid-product__secondary-image small--hide lazyload"' +
					'data-bgset="' + bgset + '"' +
					'data-sizes="auto">' +
					'</div>';
			}
		}
		} else {
		itemImagesHtml += '<div ' +
			'class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + ' lazyload"' +
			'data-bgset="' + bgset +'"' +
			'data-sizes="auto">' +
			'</div>';
		}

		if (!soldOut) {
		if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
			var bgset = buildBgSet(images[1]);
			itemImagesHtml += '<div ' +
			'class="grid-product__secondary-image small--hide lazyload"' +
			'data-bgset="' + bgset +'"' +
			'data-sizes="auto">' +
			'</div>';
		}
		}

		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Fitment from tags
		var fitmentText = ssbcExtractFitment(data.tags);
		var itemFitmentHtml = fitmentText
			? '<div class="grid-product__fitment" style="font-size:0.8em;color:#666;margin:2px 0 4px;line-height:1.3;">' + fitmentText + '</div>'
			: '';
		itemHtml = itemHtml.replace(/{{itemFitment}}/g, itemFitmentHtml);

		// Add SKU
		var itemSkuHtml = (firstVariant && firstVariant.sku)
			? '<p style="margin:0"><span><strong>SKU- ' + firstVariant.sku + '</strong></span></p>'
			: '';
		itemHtml = itemHtml.replace(/{{itemSku}}/g, itemSkuHtml);

		// Add Price
		var itemPriceHtml = '';
		if (onSale) {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
			itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
		}
		if (priceVaries) {
			itemPriceHtml += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min));
		} else {
			itemPriceHtml += Utils.formatMoney(data.price_min);
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut Label
		var itemSoldOutLabelHtml = soldOut ? '<div class="grid-product__tag">' + boostPFSConfig.label.sold_out + '</div>' : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

		// Add onSale Label
		var itemSaleLabelHtml = '';
		if (onSale && !soldOut) {
			var savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
			itemSaleLabelHtml = '<div class="grid-product__tag">' + boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice) + '</div>';
		}
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Quick shop
		var itemQuickShopClass = '';
		var itemQuickShopButtonHtml = '';
		if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
			itemQuickShopClass = 'grid-product__has-quick-shop';
			itemQuickShopButtonHtml = '<div class="quick-product__btn js-modal-open-quick-modal-{{itemId}} small--hide" data-product-id="{{itemId}}">' +
				'<span class="quick-product__label">' + boostPFSConfig.label.quick_shop + '</span>' +
				'</div>';
		}
		itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
		itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

		// Build content for Modal
		if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
			var quickUrl = Utils.buildProductItemUrl(data) + '?view=boost-pfs-quickview';
			jQ.ajax({url: quickUrl, success: function(result) {
				jQ('#QuickShopModal-' + data.id).html(result);

				if (index == totalProduct) {
					theme.initQuickShop();
					AOS.init({
						easing: 'ease-out-quad',
						once: true
					});

					window.sections = new theme.Sections();
					sections.register('product', theme.Product);
					sections.register('product-template', theme.Product);
					sections.register('collection-template', theme.Collection);
				}
			}});
		}
		// Judge.me review badge for dynamically rendered search results
		var judgeMeBadge = window.ssbcJudgeMeBadges && window.ssbcJudgeMeBadges[String(data.id)];
		var judgeMeInitialHtml = '';
		var judgeMeLoadedAttribute = '';
		if (judgeMeBadge) {
			judgeMeInitialHtml = '<div class="jdgm-widget jdgm-preview-badge jdgm-preview-badge--with-link jdgm--done-setup" style="min-height:0 !important;height:auto !important;" data-id="' + data.id + '">' + judgeMeBadge + '</div>';
			judgeMeLoadedAttribute = ' data-judgeme-loaded="true"';
		}
		var itemReviewsHtml = '<div class="ssbc-judgeme-badge-slot" data-product-handle="' + data.handle + '"' + judgeMeLoadedAttribute + '>' + judgeMeInitialHtml + '</div>';
		itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

		// Add Swatch
		var itemSwatchHtml = buildSwatch(data, this);
		itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);
		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	};
	// Build Swatch
	function buildSwatch(data, ob) {
		var _this = ob;
		var itemSwatchHtml = '';
		if (boostPFSConfig.custom.collection_color_swatches) {
			var swatch_file_extension = 'png';
			var color_count = 0 ;
			data.options_with_values.forEach(function(option, index) {
				var option_name = option.name.toLowerCase();
				if (option_name.indexOf('color')!=-1 || option_name.indexOf('colour')!=-1) {
					var option_index = index;
					var values = '';
					itemSwatchHtml += ' <div class="grid-product__colors grid-product__colors--' + data.id +'" >';
					data.variants.forEach(function(variant) {
						var temp = variant.merged_options[option_index].split(':');
						var value = temp[1];
						if ( values.indexOf(value) == -1 ) {
							color_count ++;
							values = values + ',' + value;
							values = values.split(',');
							var color_image = Utils.optimizeImage(variant.image, '50px');
							var color_swatch_fallback = value;
							var classImageSwatch = variant.image?'color-swatch--with-image color-swatch--small':'color-swatch--small';
							var attImage = '';
							if (variant.image) {
								var variant_image = Utils.optimizeImage(variant.image, '400px');
								attImage += 'data-variant-id="' + variant.id + '"';
								attImage += 'data-variant-image="'+ variant_image +'"';
							}
							itemSwatchHtml += '<a  href="' + Utils.buildProductItemUrl(data) + '?variant='+ variant.id +'"'+ attImage +' class="color-swatch '+ classImageSwatch +'" style="background-image: url('+ color_image +'); background-color: '+ color_swatch_fallback +';">';          
							itemSwatchHtml +='</a>';
						}
					});
					itemSwatchHtml += '</div>';
				}
			});
			if ( color_count < 2) {
				itemSwatchHtml += '<style>.grid-product__colors--'+ data.id +' {display: none;}</style>';
			}
		}
		return itemSwatchHtml;
	}
	/************************** END BUILD PRODUCT LIST **************************/

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (Settings.getSettingValue('general.paginationType') == 'default' && totalPage >1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml :  boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			
			return paginationHtml;
		}

		return '';
	};

	/************************** BUILD TOOLBAR **************************/

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		
		return html;
	};

	/************************** END BUILD TOOLBAR **************************/

	FilterScrollToTop.prototype.getTemplate = function() {
		return 	'<a href="javascript:;" aria-label="Back to top" class="boost-pfs-filter-scroll-to-top js-no-transition {{style}}" style="display: inline;">' +
					'<span>Back to top</span>' +
				'</a>';
	
	}

	// Load Judge.me badges only as search cards approach the viewport.
	function loadJudgeMeBadgeSlots() {
		var slots = document.querySelectorAll('.ssbc-judgeme-badge-slot:not([data-judgeme-loaded])');

		var loadSlot = function(slot) {
			if (slot.getAttribute('data-judgeme-loaded')) return;
			var handle = slot.getAttribute('data-product-handle');
			if (!handle) return;

			slot.setAttribute('data-judgeme-loaded', 'loading');
			fetch('/products/' + encodeURIComponent(handle) + '?view=judgeme-badge', {
				credentials: 'same-origin'
			})
				.then(function(response) {
					if (!response.ok) throw new Error('Judge.me badge request failed');
					return response.text();
				})
				.then(function(html) {
					slot.innerHTML = html;
					slot.setAttribute('data-judgeme-loaded', 'true');
				})
				.catch(function() {
					slot.removeAttribute('data-judgeme-loaded');
				});
		};

		if ('IntersectionObserver' in window) {
			var observer = new IntersectionObserver(function(entries) {
				entries.forEach(function(entry) {
					if (entry.isIntersecting) {
						observer.unobserve(entry.target);
						loadSlot(entry.target);
					}
				});
			}, { rootMargin: '250px 0px' });

			Array.prototype.forEach.call(slots, function(slot) {
				observer.observe(slot);
			});
		} else {
			Array.prototype.forEach.call(slots, loadSlot);
		}
	}

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data, eventType) {
		AOS.init({
			easing: 'ease-out-quad',
			once: true,
			offset: 60,
			disableMutationObserver: true
		});
		loadJudgeMeBadgeSlots();
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	};

	function buildBgSet(image) {
		var html = '';
		if (typeof image !== 'undefined' && image.hasOwnProperty('src')) {
			var aspectRatio = image.width / image.height;
			if (image.width <= 180) html += Utils.optimizeImage(image['src'], '180x') + ' 180w ' + Math.round(180 / aspectRatio) + 'h,';
			if (image.width > 180) html += Utils.optimizeImage(image['src'], '180x') + ' 180w ' + Math.round(180 / aspectRatio) + 'h,';
			if (image.width > 360) html += Utils.optimizeImage(image['src'], '360x') + ' 360w ' + Math.round(360 / aspectRatio) + 'h,';
			if (image.width > 540) html += Utils.optimizeImage(image['src'], '540x') + ' 540w ' + Math.round(540 / aspectRatio) + 'h,';
			if (image.width > 720) html += Utils.optimizeImage(image['src'], '720x') + ' 720w ' + Math.round(720 / aspectRatio) + 'h,';
			if (image.width > 900) html += Utils.optimizeImage(image['src'], '900x') + ' 900w ' + Math.round(900 / aspectRatio) + 'h,';
			if (image.width > 1080) html += Utils.optimizeImage(image['src'], '1080x') + ' 1080w ' + Math.round(1080 / aspectRatio) + 'h,';
			if (image.width > 1296) html += Utils.optimizeImage(image['src'], '1296x') + ' 1296w ' + Math.round(1296 / aspectRatio) + 'h,';
			if (image.width > 1512) html += Utils.optimizeImage(image['src'], '1512x') + ' 1512w ' + Math.round(1512 / aspectRatio) + 'h,';
			if (image.width > 1728) html += Utils.optimizeImage(image['src'], '1728x') + ' 1728w ' + Math.round(1728 / aspectRatio) + 'h,';
		}
		return html;
	}
})();


/* Begin patch boost-010 run 2 */
Filter.prototype.beforeInit=function(){var t=this.isBadUrl();t&&(this.isInit=!0,window.location.href=window.location.pathname)},Filter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var n=0;n<t.length;n++){var i=t[n],r=(i.match(/</g)||[]).length,a=(i.match(/>/g)||[]).length,o=(i.match(/alert\(/g)||[]).length,h=(i.match(/execCommand/g)||[]).length;if(r>0&&a>0||r>1||a>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
